module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.preventTouchMoveFlag) ? _c('div', {
    staticClass: "page page-current page-goods",
    style: ({
      'z-index': '1'
    }),
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.isDeskFlag) ? _c('header', {
    staticClass: "bar bar-nav",
    staticStyle: {
      "background-color": "#0894ec"
    }
  }, [(!_vm.isHomepage) ? _c('a', {
    staticClass: "icon icon-left pull-left color-wt",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "title color-wt"
  }, [_vm._v("吉凯淘基因")])]) : _vm._e(), _vm._v(" "), (_vm.navTopLevel && !_vm.isWapp) ? _c('nav', {
    staticClass: "bar bar-tab",
    staticStyle: {
      "background-color": "#F3F3F3",
      "height": "2.6rem",
      "position": "fixed"
    }
  }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.onBehalfOfCustomer === 1) ? _c('router-link', {
    staticClass: "tab-item",
    class: {
      'sales': _vm.isSalesFlag
    },
    attrs: {
      "to": {
        name: 'custOrder'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-edit"
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label"
  }, [_vm._v("定制")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    class: {
      'sales': _vm.isSalesFlag
    },
    attrs: {
      "to": {
        name: 'cart'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-cart"
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label"
  }, [_vm._v("购物车")]), _vm._v(" "), (_vm.getTotalGoodsNum > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.getTotalGoodsNum))]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    class: {
      'sales': _vm.isSalesFlag
    },
    attrs: {
      "to": {
        name: 'me'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-me"
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label"
  }, [_vm._v("我的")]), _vm._v(" "), (_vm.waitPaidAndDeliver > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.waitPaidAndDeliver) + "\n      ")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.isDeskFlag) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "-1rem",
      "height": "94%"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "keep-alive": ""
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "keep-alive": ""
    }
  }, [(!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1) : _c('div', [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "keep-alive": ""
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "keep-alive": ""
    }
  }, [(!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.isDeskFlag && !_vm.hideCustomerService) ? _c('customer-service', {
    on: {
      "preventTouchMove": _vm.handlePreventTouchMove,
      "activateTouchMove": _vm.handleActivateTouchMove
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "page page-current page-goods",
    style: ({
      'z-index': '1'
    })
  }, [(_vm.isDeskFlag) ? _c('header', {
    staticClass: "bar bar-nav",
    staticStyle: {
      "background-color": "#0894ec"
    }
  }, [(!_vm.isHomepage) ? _c('a', {
    staticClass: "icon icon-left pull-left color-wt",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "title color-wt"
  }, [_vm._v("吉凯淘基因")])]) : _vm._e(), _vm._v(" "), (_vm.navTopLevel && !_vm.isWapp) ? _c('nav', {
    staticClass: "bar bar-tab",
    staticStyle: {
      "background-color": "#F3F3F3",
      "height": "2.6rem",
      "position": "fixed"
    }
  }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.onBehalfOfCustomer === 1) ? _c('router-link', {
    staticClass: "tab-item",
    class: {
      'sales': _vm.isSalesFlag
    },
    attrs: {
      "to": {
        name: 'custOrder'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-edit"
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label"
  }, [_vm._v("定制")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    class: {
      'sales': _vm.isSalesFlag
    },
    attrs: {
      "to": {
        name: 'cart'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-cart"
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label"
  }, [_vm._v("购物车")]), _vm._v(" "), (_vm.getTotalGoodsNum > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.getTotalGoodsNum))]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    class: {
      'sales': _vm.isSalesFlag
    },
    attrs: {
      "to": {
        name: 'me'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-me"
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label"
  }, [_vm._v("我的")]), _vm._v(" "), (_vm.waitPaidAndDeliver > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.waitPaidAndDeliver) + "\n      ")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.isDeskFlag) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "-1rem",
      "height": "94%"
    }
  }, [(_vm.isWapp && !_vm.isPcUser && _vm.showBack) ? _c('div', {
    staticClass: "back-text",
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.backUrl,
      "data-src": _vm.backUrl
    }
  })]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "keep-alive": ""
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "keep-alive": ""
    }
  }, [(!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1) : _c('div', [(_vm.isWapp && !_vm.isPcUser && _vm.showBack) ? _c('div', {
    staticClass: "back-text",
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.backUrl,
      "data-src": _vm.backUrl
    }
  })]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "keep-alive": ""
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "keep-alive": ""
    }
  }, [(!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.isDeskFlag && !_vm.hideCustomerService) ? _c('customer-service', {
    on: {
      "preventTouchMove": _vm.handlePreventTouchMove,
      "activateTouchMove": _vm.handleActivateTouchMove
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03b3d9fb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1522
// module chunks = 8